const KEY_PREFIX = "VITE_";
const get = (key: string) => {
  return import.meta.env[KEY_PREFIX + key];
};

const initConsoleLog = () => {
  // live에서 console 사용하지 않음
  if (get("env.profile") == "prd") {
    console.log = () => {
    };
  }
};

const init = () => {
  initConsoleLog();
  console.log("env.profile: " + get("env.profile"));
  console.log("auth.useApigee: " + get("auth.useApigee"));
};

init();

export default {
  get(key: string) {
    return get(key);
  }
}
